export default defineNuxtPlugin(async (NuxtApp) => {
  if (NuxtApp.$env.SITE !== 'international') {
    NuxtApp.$router.getRoutes().forEach((route) => {
      if (route.meta.layout === undefined || route.meta.layout === 'default') {
        route.meta.layout = 'chiche';
      }
    })
  }
})